import { createContext, FC } from 'react';
import { ActionsFormProps } from '../../components/atoms/FormStepper/FormStepperActions';
import { StepperHeaderProps } from '../../components/atoms/FormStepper/StepperHeader';

export type FormStepperContextData = {
  readonly cancelURL: string;
  readonly translationRoot: 'offers' | 'orders' | 'products';
  readonly Actions?: FC<ActionsFormProps>;
  readonly StepperHeader?: FC<StepperHeaderProps>;
};
export const FormStepperContext = createContext<FormStepperContextData>({} as FormStepperContextData);
